export const dateInArray = (date, array) => array.some((d) => +d === +date);
